import { ethers } from 'ethers';

export const ONE_WETH = ethers.utils.parseUnits('1');
